import { CustomSettingsActions } from 'client/actions/actionTypes'
import { CustomSettingsInterface } from 'client/Interfaces/CustomSettingsInterface'
import { ExperimentInterface } from 'client/Interfaces/ExperimentsInterface'
import { QuotaTypes, SubscriptionInterface } from 'client/Interfaces/Subscription'
import { ReducerBuilder } from 'client/reducers/ReducerBuilder'
import { doesCurrentPlanSupportFeature } from 'client/reducers/Subscription/companySubscription'

type PayloadType = CustomSettingsInterface | Record<string, never>

export interface CustomSettingsState {
  loaded: boolean
  customSettings?: PayloadType
}

export const INITIAL_STATE = {
  loaded: false,
  customSettings: null,
}

const loadSettings = (state: CustomSettingsState = INITIAL_STATE, payload: PayloadType): CustomSettingsState => {
  return {
    loaded: true,
    customSettings: {
      name: payload.name,
      settings: payload.settings,
    },
  }
}

const setSettings = (state: CustomSettingsState = INITIAL_STATE, payload: PayloadType): CustomSettingsState => {
  if (payload.settings) {
    return {
      loaded: true,
      customSettings: payload,
    }
  } else {
    return state
  }
}

export default new ReducerBuilder<CustomSettingsState, PayloadType | string>(INITIAL_STATE)
  .mapAction(CustomSettingsActions.LOAD_CUSTOM_SETTINGS, loadSettings)
  .mapAction(CustomSettingsActions.UPDATE_CUSTOM_SETTINGS, setSettings)
  .build()

export const customTemplatesExperiment = (
  country: string,
  subscription: SubscriptionInterface,
  experiments: ExperimentInterface[],
): boolean => {
  if (experiments) {
    const ctExperiment = experiments.find((e) => e.experiment === 'customTemplate')
    const group = ctExperiment ? ctExperiment.group : 'B'
    if (group === 'B') {
      return false
    }
  } else {
    return subscription ? doesCurrentPlanSupportFeature(subscription, QuotaTypes.CUSTOM_INVOICE_STYLING) : false
  }

  return true
}
